export enum RideComfortAttributeAlertLevel {
  none = 'none',
  normal = 'normal',
  warning = 'warning',
  critical = 'critical',
}
